import { icons } from '@assets/icons';

import { APIconProps } from './types';

export const APIcon = ({ img, className = '', alt = '', size }: APIconProps) => {
  const iconSrc = icons[img];

  if (!iconSrc) {
    console.warn(`Icon "${img}" not found.`);
    return null;
  }

  return (
    <img
      src={iconSrc}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      className={`inline-block mr-1 ${className}`}
    />
  );
};
